import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    VStack,
    HStack,
    Tag,
    Code,
    UnorderedList,
    ListItem,
    Divider,
    Link
} from '@chakra-ui/react';
import {  } from 'react-icons/fi';
import { CheckIcon, CopyIcon } from '@chakra-ui/icons';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';
import Header from '../../components/Header';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';
import { fetchWrapper } from '../../helpers';

const ChannelOptDoc = () => {
    const [copiedSection, setCopiedSection] = useState(null);
    const [list, setList] = useState({});
    const loadList = async (id) => {

        const url = `${process.env.REACT_APP_API_URL}/customer/by-id`;
        const data = await fetchWrapper.get(url)

        setList(data.data)

    }


    useEffect(() => {

        Prism.highlightAll();
        loadList()
    }, []);

    const curlRequest = `curl --location --request PATCH '${process.env.REACT_APP_API_URL}/contacts/channel-opt-in?phone=9232321xxxx' \\
--header 'x-api-key: YOUR API KEY HERE' \\
--header 'Content-Type: application/json' \\
--data '{
  "channel_id": 4,
  "enabled": true
}'`;

    const requestPayload = `{
  "channel_id": 4,
  "enabled": true
}`;

    const successResponse = `{
  "statusCode": 200,
  "status": "success",
  "message": "Channel opt-in status updated successfully",
  "data": {
    "phone": "9232321xxxxx",
    "channel_id": 4,
    "channel_name": "IVR",
    "enabled": true,
    "updated_at": "2025-01-15T10:30:45Z"
  }
}`;

    const errorResponse = `{
  "success": false,
  "message": "Contact not found"
}`;

    const CodeBlock = ({ language, children, section }) => {
        const [copiedSection, setCopiedSection] = useState(null);

        const languageMap = {
            'bash': 'language-bash',
            'json': 'language-json',
            'gradle': 'language-gradle',
            'kotlin': 'language-kotlin',
            'java': 'language-java',
            'xml': 'language-markup',
        };

        const prismLanguage = languageMap[language] || 'language-markup';

        const copyToClipboard = (code, section) => {
            navigator.clipboard.writeText(code.trim()).then(() => {
                setCopiedSection(section);
                setTimeout(() => setCopiedSection(null), 2000);
            }).catch(err => {
                console.error('Failed to copy:', err);
            });
        };

        useEffect(() => {
            Prism.highlightAll();
        }, [children]);

        return (
            <Box position="relative">
                <pre style={{
                    backgroundColor: 'black',
                    textShadow: 'none',
                    color: 'white',
                    padding: '0px',
                    borderRadius: '8px',
                    position: 'relative'
                }}>
                    <Button
                        position="absolute"
                        top={3}
                        right={3}
                        size="sm"
                        variant="ghost"
                        colorScheme="whiteAlpha"
                        onClick={() => copyToClipboard(children, section)}
                        zIndex={10}
                    >
                        {copiedSection === section ? <CheckIcon w={3} h={3} /> : <CopyIcon w={3} h={3} />}
                    </Button>
                    <code className={prismLanguage} style={{
                        padding: '15px',
                        display: 'block',
                        backgroundColor: 'black'
                    }}>
                        {children}
                    </code>
                </pre>
            </Box>
        );
    };

    return (
        <>
            <Header />
            <BoxWrapper>
                {/* Header */}
                <Box borderBottom="1px" borderColor="#EAEAEA" bg="white">
                    <Box style={{ width: '70%' }} mx="auto" px={6} py={8}>
                        <Text fontSize={"4xl"} fontWeight={"semibold"}>
                            Channel Opt-In / Opt-Out API
                        </Text>
                        <HStack spacing={3}>
                            <Tag bg="#ad46ff" color="white" fontSize="xs" size={"sm"}>
                                PATCH
                            </Tag>
                            <Tag bg={"#fefce8"} color={"#a65f00"} border={"1px solid #fff085"}>
                                <Link color="#a65f00" fontSize="16px" fontWeight="400" my="0px" href="#">
                                    {process.env.REACT_APP_API_URL}/contacts/channel-opt-in
                                </Link>
                            </Tag>
                        </HStack>
                    </Box>
                </Box>

                {/* API Description Section */}
                <Box borderBottom="1px" borderColor="#EAEAEA">
                    <Box style={{ width: '70%' }} mx="auto" px={6} py={4}>
                        <Text fontSize="md" color="gray.700">
                            The Channel Opt-In / Opt-Out API allows you to manage opt-in status per channel for Marketing and Informational messages. You can enable or disable specific communication channels for individual contacts based on their preferences.
                        </Text>
                    </Box>
                </Box>

                {/* Main Content */}
                <Box style={{ width: '70%' }} mx="auto" px={6} py={6}>
                    <VStack spacing={10} align="stretch">

                        {/* Headers Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Headers
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" overflow="hidden" boxShadow="sm">
                                <Table variant="simple">
                                    <Thead bg="#F7F7F7">
                                        <Tr>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Header</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Value</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td fontFamily="monospace">x-api-key</Td>
                                            <Td fontFamily="monospace">{list?.api_key || "loading..."} {list.api_key && (
                                                <Text fontSize="xs" color="gray.500" mt={1}>
                                                    This is your API Key
                                                </Text>
                                            )}</Td>
                                            <Td>Your unique API authentication key</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">Content-Type</Td>
                                            <Td fontFamily="monospace">application/json</Td>
                                            <Td>Request body format</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </Box>
                        </Box>

                        {/* Query Parameters Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Query Parameters
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" overflow="hidden" boxShadow="sm">
                                <Table variant="simple">
                                    <Thead bg="#F7F7F7">
                                        <Tr>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Parameter</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Type</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Required</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td fontFamily="monospace">phone</Td>
                                            <Td>String</Td>
                                            <Td>
                                                <Tag bg="red.500" color="white" size="sm">
                                                    Required
                                                </Tag>
                                            </Td>
                                            <Td>Contact's phone number (with country code, e.g., 9232321xxxxx)</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </Box>
                        </Box>

                        {/* Request Body Parameters Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Request Body Parameters
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" overflow="hidden" boxShadow="sm">
                                <Table variant="simple">
                                    <Thead bg="#F7F7F7">
                                        <Tr>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Field</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Type</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Required</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td fontFamily="monospace">channel_id</Td>
                                            <Td>Integer</Td>
                                            <Td>
                                                <Tag bg="red.500" color="white" size="sm">
                                                    Required
                                                </Tag>
                                            </Td>
                                            <Td>Channel identifier (see Channel IDs table below)</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">enabled</Td>
                                            <Td>Boolean</Td>
                                            <Td>
                                                <Tag bg="red.500" color="white" size="sm">
                                                    Required
                                                </Tag>
                                            </Td>
                                            <Td>
                                                Set to <Code bg="gray.100" px={1} py={0.5} borderRadius="sm">true</Code> to opt-in, <Code bg="gray.100" px={1} py={0.5} borderRadius="sm">false</Code> to opt-out
                                            </Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </Box>
                        </Box>

                        {/* Channel IDs Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Channel IDs
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" overflow="hidden" boxShadow="sm">
                                <Table variant="simple">
                                    <Thead bg="#F7F7F7">
                                        <Tr>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Channel ID</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Channel Name</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td fontFamily="monospace">1</Td>
                                            <Td>SMS</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">2</Td>
                                            <Td>WhatsApp</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">3</Td>
                                            <Td>Email</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">4</Td>
                                            <Td>IVR</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">5</Td>
                                            <Td>In-App</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">6</Td>
                                            <Td>Push</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </Box>
                        </Box>

                        {/* cURL Example Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    cURL Example
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <CodeBlock language="bash" section="curl">
                                {curlRequest}
                            </CodeBlock>
                        </Box>

                        {/* Request Payload Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Request Payload
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <CodeBlock language="json" section="request">
                                {requestPayload}
                            </CodeBlock>
                        </Box>

                        {/* Success Response Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Success Response (200 OK)
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <CodeBlock language="json" section="success">
                                {successResponse}
                            </CodeBlock>
                        </Box>

                        {/* Error Response Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Error Response
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <CodeBlock language="json" section="error">
                                {errorResponse}
                            </CodeBlock>
                        </Box>

                        {/* Common Error Codes Section */}
                        <Box>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Common Error Codes
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" overflow="hidden" boxShadow="sm">
                                <Table variant="simple">
                                    <Thead bg="#F7F7F7">
                                        <Tr>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Error Code</Th>
                                            <Th fontSize="14px"
                                                fontWeight="600"
                                                color="black"
                                                textTransform="none"
                                                letterSpacing="normal">Description</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        <Tr>
                                            <Td fontFamily="monospace">403</Td>
                                            <Td>Invalid API key</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">404</Td>
                                            <Td>Contact not found with provided phone number</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">400</Td>
                                            <Td>Invalid channel ID</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">400</Td>
                                            <Td>Missing required field (channel_id or enabled)</Td>
                                        </Tr>
                                        <Tr>
                                            <Td fontFamily="monospace">500</Td>
                                            <Td>Internal server error</Td>
                                        </Tr>
                                    </Tbody>
                                </Table>
                            </Box>
                        </Box>

                        {/* Best Practices Section */}
                        <Box mb={8}>
                            <Box mb={4}>
                                <Text fontSize="2xl" mb={2} fontWeight="600">
                                    Best Practices
                                </Text>
                                <Divider borderColor="#EAEAEA" />
                            </Box>
                            <Box borderWidth="1px" borderRadius="md" p={6} boxShadow="sm">
                                <UnorderedList spacing={3} color="gray.700">
                                    <ListItem fontSize="md">Always respect user preferences and comply with GDPR and other privacy regulations</ListItem>
                                    <ListItem>Store opt-in/opt-out timestamps for audit and compliance purposes</ListItem>
                                    <ListItem>Provide clear opt-in/opt-out mechanisms in your user interface</ListItem>
                                    <ListItem>Consider implementing double opt-in for marketing communications</ListItem>
                                    <ListItem>Regularly sync contact preferences with your CRM or database</ListItem>
                                    <ListItem>Honor opt-out requests immediately to maintain trust and compliance</ListItem>
                                </UnorderedList>
                            </Box>
                        </Box>

                    </VStack>
                </Box>
            </BoxWrapper>
        </>
    );
};

export default ChannelOptDoc;